export const freeResponse = 'free_response';
export const scale = 'scale';
export const selectOne = 'select_one';
export const selectMany = 'select_many';
export const contactForm = 'contact_form';
export const statement = 'statement';
